<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_content_area">
      <router-link to="/enterprises/intern/edit" id="intern_edit" class="btn--pill pill blue">
        編輯/查看實習機構基本資料
      </router-link>
      <div class="white_block">
        <div class="search">
          <div class="search_block">
            <label>學年期：</label>
            <select v-model="searchYear" @change="internSearch" style="min-width: 174px;">
              <option value="all">全部</option>
              <option v-for="tr in yearOptions">{{ tr }}</option>
            </select>
          </div>
          <div class="search_block">
            <label>學生：</label>
            <select v-model="searchStudent" @change="internSearch" style="min-width: 174px;">
              <option value="all">全部</option>
              <option v-for="tr in studentOptions" :value="tr.student_id">{{ tr.student_name }}</option>
            </select>
          </div>
        </div>
        <div class="table_holder">
          <table>
            <thead>
              <tr> <th>學年期</th> <th>學生就讀系所</th> <th>學號</th> <th>姓名</th> <th>詳細資料</th> </tr>
            </thead>
            <tbody>
              <tr v-for="tr of currentInternRecordListGetter">
                <td>{{ tr.year }}</td>
                <td>{{ tr.department }}</td>
                <td>{{ tr.student_account }}</td>
                <td>{{ tr.student_name }}</td>
                <td>
                  <router-link
                    :to="`/enterprises/intern/intern-record/${tr.year}/${tr.student_id}`"
                    class="btn--pill pill blue d-inline-block"
                  >詳細資料</router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import '~style/components/custom_table.scss'
export default {
  name: 'EnterprisesInternStudentListContent',
  components: {
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentInternStatusGetter',
      'currentInternSearchOptionsGetter',
      'currentInternRecordListGetter',
    ]),
    yearOptions() {
      return this.currentInternSearchOptionsGetter.year || [];
    },
    studentOptions() {
      return this.currentInternSearchOptionsGetter.student || [];
    },
  },
  data () {
    return {
      searchYear: 'all',
      searchStudent: 'all',
    };
  },
  async created () {
    this.togglePageLoader(true);
    await this.getEnterpriseInternForm();
    if(this.currentInternStatusGetter == 'is_enabled') {
      await this.getInternSearchOptions();
      await this.getInternRecordList({});
      this.togglePageLoader(false);
    }
    else {
      this.$router.push({ path: '/enterprises' });
    }
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/enterprises', [
      'getEnterpriseInternForm',
      'getInternSearchOptions',
      'getInternRecordList',
    ]),
    internSearch () {
      let search_data = {};
      if(this.searchYear != 'all') {
        search_data.year = this.searchYear;
      }
      if(this.searchStudent != 'all') {
        search_data.student_id = this.searchStudent;
      }
      this.getInternRecordList(search_data);
    },
  }
}
</script>
<style lang="scss" scoped>
#intern_edit {
  position: absolute;
  top: -50px;
  right: 15px;
  line-height: 35px;
  
  @media (max-width: 768px) {
    top: -40px;
    line-height: 30px;
    height: 30px;
  }
}
  .search {
    display: flex;
    align-items: center;
    gap: 12px 40px;
    flex-wrap: wrap;
    padding: 8px;
    margin-bottom: 12px;
  }
  .search_block { display: flex; align-items: center; gap: 20px; flex-wrap: wrap; }
  .search label { margin: 0; }
  .search select {
    background: #fff;
    height: 29px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    outline: none;
  }
</style>
